
import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module'
import { InputLabelContainer } from '../../../../../../common/components/form/label/containers/input-label.container'
import { InputContainer } from '../../../../../../common/components/form/form.module'
import { format } from '../../../../../../common/services/date.service'

export default function LogisticQuoteBasicInfoComponent ({quoteDetails,handleInnerFormChange }: any) {

  return (
    <>
 <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <div><InputLabelContainer label="CategoryName" />
        <InputLabelContainer label={quoteDetails?.category_name}/></div>
      <InputContainer
              isDisabled
              label="Active"
              name="IsActive"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'quoteDetails.IsActive'
                )
              }}
              type="checkbox"
              value={quoteDetails?.IsActive}
          />
          <InputContainer
              isDisabled
              label="Deleted"
              name="IsDeleted"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsDeleted'
                )
              }}
              type="checkbox"
              value={quoteDetails?.IsDeleted}
          />
          <div>
          <InputLabelContainer
              label="Created On"
          />
          <InputLabelContainer
              label={format(quoteDetails?.CreatedOnUtc)}
          /></div>
       <div>
          <InputLabelContainer
              label="Modified On"
          />
          <InputLabelContainer
              label={format(quoteDetails?.ModifiedOnUtc)}
          /></div>
       </div>
  }
  expandedPanel="userInfo"
  headerTitle="Basic Info"
/>

    
        </>
  )
}